import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import { PhoneInput, PhoneInputPropsT } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/input.scss';

export type NcPhoneInputPropsT = PhoneInputPropsT;

export type NcPhoneInputT = React.FC<NcPhoneInputPropsT>;

export const NcPhoneInput: NcPhoneInputT = ({
  className,
  ...props
}) => {
  const cssClasses = mergeClassNameStrings('nc-input', className);

  return (
    <PhoneInput
      className={cssClasses}
      {...props}
    />
  );
};
